import Vue from 'vue';
// Shared by the reminder notice and Settings: set when the player answered the notice with
// 开启提醒 but cancelled WeChat's popup, so Settings can say why reminders are off.
export const noticeState = Vue.observable({ rejected: false });
